// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Un1x","validationTips":"StatementDescriptor_validationTips__2QzLu"};